<div class="w-full h-full"
     id="app-router-outlet">
  <router-outlet></router-outlet>
</div>
<app-loading-screen *ngIf="isLoadingScreenOpen"></app-loading-screen>
<app-print-container id="print-container"></app-print-container>

<!-- notification section -->

<!--  this code is added here because prime ng was not able to host host
different component  in ng-template-->
<p-toast [baseZIndex]="5000"
         key="confirm"
         position="bottom-right">
  <ng-template let-message
               pTemplate="message">
    <div class="flex flex-column align-items-start"
         style="flex: 1">
      <div (click)="openNotificationDetails()"
           class="w-full notification-container-wrapper">
        <div
          class="notification-title-section">
          {{message?.title}}
        </div>
        <div [innerHTML]="message?.message"
             class="notification-content-section">
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<!-- notification section -->
